<template>
    <!-- to be used in live sale -->
    <div>
        <!-- checkout form complete -->
        <div class="container" v-if="getCheckoutFormVisible && !orderCompletedVisible">
            <div class="card mt-4 col-md-12 col-lg-12 col-xl-8 offset-xl-2">
                <div class="card-header">
                    <h3>1. Os seus dados básicos</h3>
                </div>
                <div class="card-body p-2 p-md-4">
                    <p>
                        Precisamos de dados básicos para entregar a suas fotos
                        e para enviar as fotos digitais selecionadas para si.
                    </p>
                    <div class="row">
                        <div class="col-md-12 col-sm-12">
                            <label>Nome <i class="mandatory"></i></label>
                            <input
                                v-model="order.client_name"
                                required
                                type="text"
                                placeholder="Indique o seu nome"
                                class="form-control"
                                @blur="checkError($event, 'name')"
                            />
                            <span class="error-message" v-if="errors.name"
                            >O campo nome é obrigatório.</span
                            >
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-sm-12 mt-3">
                            <label>E-mail</label>
                            <input
                                v-model="order.email"
                                type="email"
                                placeholder="Indique o seu e-mail (opcional)"
                                class="form-control"
                            />
                            <small
                            >Iremos utilizar o seu e-mail para enviar as suas fotos em formato digital.</small
                            >
                        </div>
                        <div class="col-md-6 col-sm-12 mt-3">
                            <label>Telemóvel</label>
                            <input
                                type="phone"
                                placeholder="Indique o seu telemóvel (opcional)"
                                class="form-control"
                                v-model="order.phone"
                            />
                            <!-- <small>Iremos notificá-lo através de e-mail quando a
                                suas fotos forem enviadas.</small> -->
                        </div>
                    </div>
                </div>
            </div>

            <div class="card mt-4 col-md-12 col-lg-12 col-xl-8 offset-xl-2">
                <div class="card-header">
                    <h3>2. O que vamos entregar/enviar</h3>
                </div>
                <div class="card-body p-4 items-review">
                    <div
                        class="row mt-4 mb-4"
                        v-for="(item, index) in cart"
                        :key="index"
                    >
                        <div class="col-md-4 col-sm-6 col-xs-12">
                            <img :src="item.image.thumbnail"/>
                        </div>
                        <div class="col-md-8 col-sm-6 col-xs-12">
                            <div class="row">

                                <div class="col-md-12">
                                    <div class="row item-list">
                                        <p><small>Cód. Interno #{{ item.image.id }}</small>
                                            <br>{{ item.image.original_filename }}</p>
                                    </div>
                                </div>

                                <div class="col-xs-6 col-md-12">
                                    <table>
                                        <tr v-for="(size, sidx) in item.sizes" :key="sidx" class="row">
                                            <td>{{ size.quantity }} &times;
                                                {{ getImageSizeNameById(size.image_size_id) }}
                                            </td>
                                        </tr>
                                    </table>
                                    <!--
                                                                        <div v-for="(size, sidx) in item.sizes" :key="sidx" class="row">

                                                                            <div class="col-6">
                                                                                {{ size.quantity }} &times;
                                                                                {{ getImageSizeNameById(size.image_size_id) }}
                                                                            </div>
                                                                            <div class="col-2"> {{ parseDecimalPlaces(size.line_price) }} &euro;</div>
                                                                        </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 total">
                            <b>Total a Pagar </b>
                            <span class="ml-4 total-money"
                            >{{
                                    parseDecimalPlaces(totalPrice)
                                }}
                                &euro;</span
                            >
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="card mt-4 col-md-12 col-lg-12 col-xl-8 offset-xl-2 mb-4"
            >
                <div class="card-header">
                    <h3>3. Pagamento</h3>
                </div>
                <div class="card-body p-4">
                    <p>
                        O pagamento é efetuado no momento do levantamento das suas fotos!<br>
                        Pode efetuar o pagamento através de <b>numerário</b> ou através de <b>MBWay</b>
                    </p>
                    <div class="col-md-10 col-sm-12 mt-2 ml-2">
                        <input
                            checked="checked"
                            type="radio"
                            class="form-check-input"
                            value="4"
                            v-model="order.payment_method_id"

                        />
                        <label for="check1" class="form-check-label">Pagamento no ato de entrega</label>
                    </div>
                </div>
            </div>
            <div
                class="card mt-4 col-md-12 col-lg-12 col-xl-8 offset-xl-2 mb-4"
            >
                <div class="card-header">
                    <h3>4. Concluir Encomenda </h3>
                </div>
                <div class="card-body mt-4">
                    <p> Para concluir a sua encomenda, clique botão <b>"Encomendar as minhas Fotos"</b>. </p>
                    <p>
                        Após este passo, iremos processar o seu pedido e iremos
                        proceder à produção das fotografias que selecionou e iremos
                        notificá-lo quando estiverem prontas. Após pagamento, iremos enviá-las para o seu e-mail.
                    </p>
                    <div class="text-center mt-5">
                        <b-overlay :show="isSaving">
                            <button
                                type="button"
                                class="btn-primary btn p-3"
                                :disabled="!isFormValid"
                                @click="placeOrder"
                                style="font-size: 1rem"
                            >
                                Encomendar as Minhas Fotos <i class="fa fa-check"></i>
                            </button>
                        </b-overlay>
                    </div>
                </div>
            </div>
        </div>

        <!-- order complete -->
        <div class="container mb-5 mt-5" v-if="orderCompletedVisible">
            <div class="card">
                <div class="card-header">
                    <h3 class="mb-2">Fantástico! Encomenda concluída</h3>
                </div>
                <div class="card-body">
                    <h4>Vamos imprimir as suas fotos de seguida!</h4>

                    <div class="row">
                        <p> O código da sua encomenda é</p>
                        <div class="p-3">
                            <p style="font-size: 16px; padding: 10px; width: 100%; border: solid 1px #a0a0a0; background-color: #efefef; text-align: center">
                                <b>{{ order.order_no }}</b></p>
                        </div>
                        <p> Informe este código no momento do levantamento das suas fotos.</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xl-8 col-md-10 col-sm-12 m-auto mt-5">
                        <p class="text-center">
                            Qualquer dúvida ou questão, por favor, dirija-se a um membro da nossa equipa para o
                            ajudar!
                        </p>
                    </div>
                    <div class="col-12 pb-4">
                        <hr/>
                        <div class="col-md-4 m-auto text-center mt-3">
                            <button class="btn btn-outline-primary" @click="showGallery"> Voltar à galeria</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import OrderAPI from "../api/OrderAPI.js";

export default {
    // this component is only used in a live sale
    name: "CartFormComponentSale",
    props: ['gallery'],
    data() {
        return {
            isSaving: false,
            errors: {
                name: false,
                address: false,
                zip_code: false,
                locality: false,
            },
            formValidated: false,
            order: {
                id: null,
                client_name: "",
                ship_same_address: true,
                total: 0.0,
                payment_method_id: 4,
                phone: "",
                email: "",
            },
        };
    },
    methods: {
        getImageSizeNameById(image_size_id) {
            const size = this.imageSizes.find(
                (elem) => elem.id == image_size_id
            );
            if (size) {
                return size.name;
            }
            return "";
        },
        parseDecimalPlaces(value) {
            return Number(
                Math.round(parseFloat(value + "e" + 2)) + "e-" + 2
            ).toFixed(2);
        },
        // check input for error
        checkError(event, field) {
            this.formValidated = true;
            if (event.target.value.toString().length < 2) {
                this.errors[field] = true;
            } else {
                this.errors[field] = false;
            }
            this.validateForm();
        },
        validateForm() {
            if (this.order.payment_method_id === undefined || this.order.payment_method_id == null) {
                console.log('Check payment method');
                return false;
            }

            if (this.formValidated && (this.order.client_name.length < 2)) {
                console.log('Check Client Data');
                return false;
            }

            return true;
        },

        // create order
        placeOrder() {
            this.isSaving = true;
            let self = this;
            let orderAPI = new OrderAPI();

            let newOrder = this.order;
            newOrder.order_lines = this.cart;
            newOrder.gallery_id = this.gallery.id;

            orderAPI.store(newOrder)
                .then((res) => {
                    if (res.status === 201) {
                        self.$store.dispatch("updateOrder", res.data.data);
                        self.isSaving = false;
                        self.$store.dispatch("hideCheckoutForm");
                        self.$store.dispatch("setOrderCompleteVisible", true);
                        // clean up cart
                        self.$store.dispatch("emptyCart");
                        self.order = res.data.data;
                    }
                })
                .catch((err) => {
                    alert('Ocorreu um erro. Por favor, tente novamente dentro de instantes');
                    this.isSaving = false;
                    console.log(err);
                });
        },
        showGallery() {

            if (this.order.id !== null) {
                this.order = {
                    id: null,
                    client_name: "",
                    ship_address_1: "",
                    locality: "",
                    zip_code: "",
                    ship_same_address: true,
                    total: 0.0,
                    payment_method_id: 4,
                    phone: "",
                    email: ""
                }
            }
            this.$store.dispatch("showGallery");
            var element = document.getElementsByClassName("gallery");
            var top = element.offsetTop;
            window.scrollTo(0, top);
            this.$store.dispatch("setOrderCompleteVisible", false);
            this.$store.dispatch("resetOrder");
        },
    },
    computed: {
        isFormValid() {
            return this.validateForm();
        },
        ...mapGetters({
            getCheckoutFormVisible: "getCheckoutFormVisible",
            orderCompletedVisible: "orderCompletedVisible",
            cart: "getCart",
            imageSizes: "imageSizes",
            totalPrice: "getTotalPrice",
        }),
    },
    watch: {
        order: {
            deep: true,
            handler: function () {
                this.$store.dispatch("updateOrder", this.order);
            },
        },
    },
    mounted() {
        const order = this.$store.getters.getOrder;
        if (order) {
            this.order = {...this.order, ...order};
        }
        this.validateForm();

    },
};
</script>
